import {
    LOGIN_USER,
    LOGOUT_USER
} from '../types';

let user = JSON.parse(localStorage.getItem('user'));

const initialState = {
    user,
}

export default function(state = initialState, action) {
    switch(action.type) {
        case LOGIN_USER:
            //localStorage.setItem('user', JSON.stringify(action.payload));
            return {
                ...state,
                user: action.payload
            };
        case LOGOUT_USER:
            //localStorage.removeItem('user');
            return {
                ...state,
                user: null
            }
        default:
            return state;
    }
}